import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Upload from '@/views/Upload.vue'
import store  from '@/store'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Upload',
    component: Upload
  },
  {
    path: '/history',
    name: 'History',
    component: () => import('../views/History.vue')
  },
  {
    path: '/history-*',
    component: () => import('../views/HistoryList.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const state: any = store.state
  store.dispatch('app/setUpload', false)
  if(to.path !== '/' && !state.app.isLogin){
    next('/')
  } else {
    next()
  }
})

export default router
